import { Suspense } from 'react'

import { AnyRoute, Outlet, createRoute } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { CircularProgress } from 'ui/components'

import { HighRiskDetailsRoute } from './routes'

export const routeHighRiskTree = <T extends AnyRoute>(indexRoute: T) => {
  const HighRiskRoute = createRoute({
    getParentRoute: () => indexRoute,
    path: routes.bank.hrr.index,
    component: () => (
      <Suspense fallback={<CircularProgress centered />}>
        <Outlet />
      </Suspense>
    )
  })

  return HighRiskRoute.addChildren([HighRiskDetailsRoute(HighRiskRoute)])
}
